import React, { useEffect, useState, useRef,  useLayoutEffect, useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// COMPONENTS
import Total from '../components/Total';
import DateSelection from '../components/DateSelection';
import Table2 from '../components/Table2';
import TrainingProgTable from '../components/TrainingProgTable';
import LeftComboGraph from '../components/LeftComboGraph';
import RightComboGraph from '../components/RightComboGraph';
import CertificateCard from '../components/CertificateCard';

// PROCESSES
import { procTraineeUnityData } from '../processes/fetchUserDataRtkQ';

// REDUX
import { setCurrentPage } from '../redux/app.slice';
import { useGetChaptersQuery, useGetUserDataQuery } from '../apis/rtkData.api';
// API
// import { fetchChapterDataApi, getChapterGroupApi } from '../apis/data.api';

// Icons
import SessionIcon from '../assets/session-32x32.png';
import NegotiationIcon from '../assets/negotiation-32x32.png';

const TraineeDash = () => {
  // console.log('TraineeDash RENDERING');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userData, setUserData] = useState({});
  const [loadTest, setLoadTest] = useState(false); // eslint-disable-line
  const [startDate, setStartDate] = useState(new Date('07/01/23'));
  const [endDate, setEndDate] = useState(new Date());
  const [table2bData, setTable2bData] = useState([]);
  const [topNegTableData, setTopNegTableData] = useState([]);
  // const [trainingProgData, setTrainingProgData] = useState([]);
  const [duration, setDuration] = useState(0);
  const [moduleScores, setModuleScores] = useState({});
  const [moduleCount, setModuleCount] = useState(0); // eslint-disable-line
  // const [chapters, setChapters] = useState([]);
  // const [ chapterGroup, setChapterGroup ] = useState({});
  const [negotiationCount, setNegotiationCount] = useState(0);
  const [negotiationTime, setNegotiationTime] = useState(0);
  const { loginStatus } = useSelector((state) => state.user, shallowEqual); // eslint-disable-line
  const { reactVerbosity } = useSelector((state) => state.app); // eslint-disable-line
  const { privacy } = useSelector((state) => state.app, shallowEqual); // eslint-disable-line
  const { user } = useSelector((state) => state.user, shallowEqual); // eslint-disable-line

  const [showFloatingButton, setShowFloatingButton] = useState(false);
  const [isTabsSticky, setIsTabsSticky] = useState(false);
  const contentRef = useRef(null);
  const tabsRef = useRef(null);

  const [activeTab, setActiveTab] = useState('Trainee Analytics');
  const [showCertificateCard, setShowCertificateCard] = useState(true);

  const selection = {
    startDate,
    endDate
  };
  /* eslint-disable */
  const {           
    data: chData,
    error,
    isLoading: isLoadingChData,
    isSuccess,
    isError,
    isFetching
  } = useGetChaptersQuery({
    authToken: user.idToken,
    user,
    selection
  }); 
  const {
    data: usrData,
    error: usrErr,
    isLoading: isLoadingUsrData,
    refetch: refetchUserData
  } = useGetUserDataQuery({
    authToken: user.idToken,
    user,
    selection
  }); 
  /* eslint-enable */

  useEffect(() => {
    dispatch(setCurrentPage('traineeDash'));
  }, []);

  // useEffect(() => {
  //   getChapterGroup();
  // }, [user]);

  // const getChapterGroup = async () => {
  //   const chGrp = await getChapterGroupApi(user.idToken, 'default');
  //   // console.log('--------------> LeaderDash chGrp:', chGrp)
  //   // if (chGrp.err) {
  //   //   setRevalidate((revalidate) => revalidate+1);
  //   // }
  //   setChapterGroup(chGrp);
  // }

  useEffect(() => {
    window.addEventListener('popstate', (e) => {
      navigate('/', { replace: false });
    });
    return async () => {};
  }, []); // eslint-disable-line

  useEffect(() => {
    if (Object.keys(userData).length > 0) {
      // console.log('+++++> USER DATA:', userData)
      buildDataForTopNegTable();
      buildDataForTable2b();
      // buildDataForTrainingProgressTable();
    }
  }, [userData && userData.sessionCount]);

  useEffect(() => {
    if (!isLoadingUsrData) {
      fetchUserDataProcess();
    }
  }, [isLoadingUsrData, usrData]); // eslint-disable-line

  const handleDateChange = useCallback((start, end) => {
    console.log('handleDateChange start, end:', start, end);
    setStartDate(start);
    setEndDate(end);
    // Don't call fetchUserDataProcess here, it will be triggered by the useEffect
  }, []);

  const fetchUserDataProcess = async () => {
    // const chapterData = await fetchChapterDataApi(user.idToken, user);
    const { userDataObj } = await procTraineeUnityData(usrData);

    reactVerbosity === 2 &&
      console.log('=======> fetchTraineeUnityData:', userDataObj);
    setDuration(userDataObj.duration);
    setNegotiationCount(userDataObj.negotiations);
    setNegotiationTime(userDataObj.time);
    setModuleCount(userDataObj.modules);
    // setChapters(chapterData.data);
    setModuleScores(userDataObj.moduleScoreObj);
    setUserData(userDataObj);
  };

  // const buildDataForTrainingProgressTable = async () => {
  //   // console.log('+++++> USER DATA:', userData)
  //   const lessons = {};
  //   const quizzes = {};
  //   const selfAssessments = {};

  //   const tableData =
  //     userData.sessions &&
  //     userData.sessions.map((s, index) => {
  //       // console.log("==========[> index, s:", index, s)
  //       return s.unitysessionmodules.map((m, i) => {  // eslint-disable-line
  //         // console.log('==========[> i, m:', i,  m)
  //         if (m.moduleType === 'lesson' && m.userScore !== -1 && m.userScore !== 0) {
  //           let date = new Date(s.sessionStartTime).toISOString().split('T')[0];
  //           const dateArr = date.split('-');
  //           date = dateArr[1] + '-' + dateArr[2] + '-' + dateArr[0];

  //           if (!lessons[s.user.name]) lessons[s.user.name] = {};
  //           if (!lessons[s.user.name][m.moduleName]) { lessons[s.user.name][m.moduleName] = {}; }
  //           lessons[s.user.name][m.moduleName] = {
  //             // moduleType: m.moduleType,
  //             moduleType: 'Lesson',
  //             module: m.moduleName,
  //             user: s.user.name,
  //             userScore: m.userScore,
  //             complete: m.userScore === -1 ? 'X' : '\u2713',
  //             date
  //           };
  //         }
  //         if (m.moduleType === 'quiz' && m.userScore !== -1 && m.userScore !== 0) {
  //           let date = new Date(s.sessionStartTime).toISOString().split('T')[0];
  //           const dateArr = date.split('-');
  //           date = dateArr[1] + '-' + dateArr[2] + '-' + dateArr[0];

  //           if (!quizzes[s.user.name]) quizzes[s.user.name] = {};
  //           if (!quizzes[s.user.name][m.moduleName]) { quizzes[s.user.name][m.moduleName] = {}; }
  //           quizzes[s.user.name][m.moduleName] = {
  //             // moduleType: m.moduleType,
  //             moduleType: 'Quiz',
  //             module: m.moduleName,
  //             user: s.user.name,
  //             userScore: m.userScore,
  //             complete: m.userScore === -1 ? 'X' : '\u2713',
  //             date
  //           };
  //         }

  //         if (m.moduleType === 'selfassessment' && m.userScore !== -1 && m.userScore !== 0) {
  //           let date = new Date(s.sessionStartTime).toISOString().split('T')[0];
  //           const dateArr = date.split('-');
  //           date = dateArr[1] + '-' + dateArr[2] + '-' + dateArr[0];

  //           if (!selfAssessments[s.user.name]) selfAssessments[s.user.name] = {};
  //           if (!selfAssessments[s.user.name][m.moduleName]) { selfAssessments[s.user.name][m.moduleName] = {}; }
  //           selfAssessments[s.user.name][m.moduleName] = {
  //             moduleType: 'Self Assessment',
  //             module: m.moduleName,
  //             user: s.user.name,
  //             userScore: m.userScore,
  //             complete: m.userScore === -1 ? 'X' : '\u2713',
  //             date
  //           };
            
  //         }
  //         if (Object.keys(lessons).length === 0) {
  //           lessons[s.user.name] = {};
  //         }
  //         if (Object.keys(quizzes).length === 0) {
  //           quizzes[s.user.name] = {};
  //         }
  //         if (Object.keys(selfAssessments).length === 0) {
  //           selfAssessments[s.user.name] = {};
  //         }
          
  //         // console.log('------> lessons:', lessons)
  //         // console.log('------> quizzes:', quizzes)
  //         // console.log('------> selfAssessments:', selfAssessments)

  //         if (m.moduleType !== 'negotiation') {
  //           let date = new Date(s.sessionStartTime).toISOString().split('T')[0];
  //           const dateArr = date.split('-');
  //           date = dateArr[1] + '-' + dateArr[2] + '-' + dateArr[0];
  //           return {
  //             moduleType: m.moduleType,
  //             module: m.moduleName,
  //             user: s.user.name,
  //             userScore: m.userScore,
  //             complete: m.userScore === -1 ? 'X' : '\u2713',
  //             date
  //           };
  //         }
  //       });
  //     });
  //   const arrFiltered = await filterNull(tableData);
  //   const flattened = arrFiltered.flat();
  //   const flattenedFiltered = flattened.filter((elements) => {
  //     return elements !== null && elements !== undefined;
  //   });

  //   // console.log('=============> buildDataForTrainingProgressTable flattenedFiltered DATA:', flattenedFiltered);
    
  //   reactVerbosity === 2 && console.log('==========> chapters:', chapters);
  //   // console.log('==========> chapters:', chapters);
  //   let chapterLessons = [];
  //   let chapterQuizzes = [];
  //   let chapterSelfAssessments = [];

  //   chapters && chapters.forEach((c) => {

  //     // console.log("====> c:", c)

  //       c.lessons.forEach((l) => {
  //         chapterLessons = [
  //           ...chapterLessons,
  //           {
  //             chapter: c.title,
  //             chapterId: c._id,
  //             chapterIndex: c.chapterIndex,
  //             number: l.moduleIndex,
  //             moduleType: 'Lesson',
  //             module: l.moduleName,
  //             userScore: -1,
  //             complete: 'X',
  //             date: ''
  //           }
  //         ];
  //       });

  //       c.quizzes.forEach((q) => {
  //         // console.log(`c: ${c.title}, q:`, q)
  //         chapterQuizzes = [
  //           ...chapterQuizzes,
  //           {
  //             chapter: c.title,
  //             chapterId: c._id,
  //             chapterIndex: c.chapterIndex,
  //             number: q.moduleIndex,
  //             moduleType: 'Quiz',
  //             module: q.moduleName,
  //             userScore: -1,
  //             complete: 'X',
  //             date: ''
  //           }
  //         ];
  //       });

  //       c.selfassessments && c.selfassessments.forEach((sa) => {
  //         // console.log('====> sa:', sa, chapterSelfAssessments)
  //         chapterSelfAssessments = [
  //           ...chapterSelfAssessments,
  //           {
  //             chapter: c.title,
  //             chapterIndex: c.chapterIndex,
  //             chapterId: c._id,
  //             number: sa.moduleIndex,
  //             moduleType: 'Self Assessment',
  //             module: sa.moduleName,
  //             userScore: -1,
  //             complete: 'X',
  //             date: ''
  //           }
  //         ];
  //       });

  //     });
    
  //   // console.log("====> chapterLessons (291):", chapterLessons)
  //   // console.log("====> chapterQuizzes (292):", chapterQuizzes)  // missing chapter-quizzes
  //   // console.log("====> chapterSelfAssessments (293):", chapterSelfAssessments)
    
  //   const rebuiltTableData = [];
  //   const lessonKeys = Object.keys(lessons);
  //   lessonKeys.forEach((k) => {
  //     chapterLessons.forEach((l) => {
  //       l.user = k;
  //       if (!lessons[k][l.module]) {
  //         lessons[k][l.module] = { ...l };
  //       } else {
  //         lessons[k][l.module].chapter = l.chapter;
  //         lessons[k][l.module].number = l.moduleIndex;
  //       }
  //       rebuiltTableData.push(lessons[k][l.module]);
  //     });
  //   });
  //   // console.log("----> lessons:", lessons)
  //   const quizKeys = Object.keys(quizzes);
  //   quizKeys.forEach((k) => {
  //     chapterQuizzes.forEach((q) => {
  //       q.user = k;
  //       if (!quizzes[k][q.module]) {
  //         quizzes[k][q.module] = { ...q };
  //       } else {
  //         quizzes[k][q.module].chapter = q.chapter;
  //         quizzes[k][q.module].number = q.moduleIndex;
  //       }
  //       rebuiltTableData.push(quizzes[k][q.module]);
  //     });
  //   });
  //   // console.log("----> quizzes:", quizzes)
  //   const selfAssessmentKeys = Object.keys(selfAssessments);
  //   selfAssessmentKeys.forEach((k) => {
  //     chapterSelfAssessments.forEach((sa) => {
  //       sa.user = k;
  //       // console.log("====> sa.user, sa:", sa.user, sa)
  //       // console.log("======> selfAssessments[k]:", selfAssessments[k])
  //       if (!selfAssessments[k][sa.module]) {
  //         selfAssessments[k][sa.module] = { ...sa };
  //       } else {
  //         selfAssessments[k][sa.module].chapter = sa.chapter;
  //         selfAssessments[k][sa.module].number = sa.moduleIndex;
  //       }
  //       rebuiltTableData.push(selfAssessments[k][sa.module]);
  //     });
  //   });

  //   reactVerbosity === 2 &&
  //     console.log('===> rebuiltTableData:', rebuiltTableData);

  //   let chapterGroupObj = {};
  //   rebuiltTableData.forEach((m) => {
  //       if (!chapterGroupObj[m.chapterIndex]) chapterGroupObj[m.chapterIndex] = [];
  //       chapterGroupObj[m.chapterIndex] = [...chapterGroupObj[m.chapterIndex], m];
  //   })
  //   // console.log('chapterGroupObj:', chapterGroupObj)
  //   const cgKeys = Object.keys(chapterGroupObj);
  //   let concatenatedTableData = [];
  //   cgKeys.map((k) => {
  //     return concatenatedTableData = [...concatenatedTableData, chapterGroupObj[k]]
  //   })

  //   setTrainingProgData(concatenatedTableData.flat());
  //   return concatenatedTableData.flat();
  // };

  const buildDataForTopNegTable = async () => {
    // console.log('+++++> USER DATA:', userData)
    // TOP NEGOTIATIONS
    const validModuleTypes = Object.keys(userData.totalModulesByType);
    const tableData =
      userData.sessions &&
      userData.sessions.map((s, index) => {
        return s.unitysessionmodules.map((m, i) => {
          if (
            m.moduleType === 'negotiation' &&
            s.sessionLength > 0 &&
            m.userScore > 0 &&
            validModuleTypes.includes(m.moduleName)
          ) {
            // console.log('==========[> i, m:', i,  m, m.moduleName, userData.totalModulesByType)
            // console.log("TRAINEE =========> moduleScoreObj:", userData.moduleScoreObj)
            let date = new Date(s.sessionStartTime).toISOString().split('T')[0];
            const dateArr = date.split('-');
            date = dateArr[1] + '-' + dateArr[2] + '-' + dateArr[0];
            const moduleCountByType = userData.totalModulesByType[m.moduleName]
              ? userData.totalModulesByType[m.moduleName].length
              : 0;
            // console.log('TRAINEE =====> TopNegTable moduleCountByType:', moduleCountByType)
            const maxUserScore = Math.max(...userData.moduleScoreObj[m.moduleName]);
            // console.log("TRAINEE ======> m.moduleName, maxUserScore:", m.moduleName, maxUserScore,userData.moduleScoreObj[m.moduleName])
            return {
              negotiation: m.moduleName,
              user: s.user.name,
              userScore: maxUserScore,
              maxScore: m.maxScore,
              moduleCountByType,
              date
            };
          } else return null;
        });
      });
    const arrFiltered = await filterNull(tableData);
    const flattened = arrFiltered.flat();
    const flattenedFiltered = flattened.filter((e) => !Array.isArray(e));
    // console.log('buildDataForTable2 tableData, flattened, flattenedFiltered DATA:', tableData, flattened, flattenedFiltered)
    const uniqueModules = Array.from(
      new Set(flattenedFiltered.map((a) => a.negotiation))
    ).map((negotiation) => {
      return flattenedFiltered.find((a) => a.negotiation === negotiation);
    });
    setTopNegTableData(uniqueModules);
    reactVerbosity === 2 &&
      console.log('buildDataForTopNegTable uniqueModules DATA:', uniqueModules);
    return uniqueModules;
  };

  const buildDataForTable2b = async () => {
    const tableData =
      userData.sessions &&
      userData.sessions.map((s, index) => {
        // console.log('=========[> data Table2b SESSION:', s)
        return s.unitysessionmodules.map((m, i) => {
          if (m.moduleType === 'negotiation') {
            let date = new Date(s.sessionStartTime).toISOString().split('T')[0];
            const dateArr = date.split('-');
            date = dateArr[1] + '-' + dateArr[2] + '-' + dateArr[0];
            const moduleCountByType = userData.totalModulesByType[m.moduleName]
              ? userData.totalModulesByType[m.moduleName].length
              : 0;
            // console.log('TRAINEE table2bData moduleCountByType:', moduleCountByType)

            return {
              negotiation: m.moduleName,
              user: s.user.name,
              userScore: m.userScore,
              maxScore: m.maxScore,
              moduleScores,
              moduleCountByType,
              date
            };
          } else return null;
        });
      });
    // console.log('buildDataForTable2 tableData DATA:', tableData);
    const arrFiltered = await filterNull(tableData);
    // console.log('buildDataForTable2 arrFiltered DATA:', arrFiltered);
    let flattened = arrFiltered.flat();
    flattened = flattened.filter((e) => !Array.isArray(e));
    setTable2bData(flattened);
    // console.log('buildDataForTable2 flattened DATA:', flattened);
    reactVerbosity === 2 &&
      console.log('buildDataForTable2 flattened DATA:', flattened);
    return flattened;
  };

  const filterNull = (tableData) => {
    return tableData.map((e) => {
      return e.map((m) => {
        if (m !== null && m !== undefined) {
          return m;
        }
        return [];
      });
    });
  };

  const setDefaultDates = async (start, end) => {
    await setStartDate(start);
    await setEndDate(end);
  };

  const handleStartDate = (date) => {
    setStartDate(date);
  };

  const handleEndDate = (date) => {
    setEndDate(date);
  };

  const handleFloatingButtonClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useLayoutEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setShowFloatingButton(scrollPosition > 300);

      if (tabsRef.current) {
        const tabsPosition = tabsRef.current.getBoundingClientRect().top;
        setIsTabsSticky(tabsPosition <= 0);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-gray-100 min-h-screen p-6 relative" ref={contentRef}>
      <div className="space-y-6">
        <header>
          <h1 className="text-3xl font-bold text-gray-800 mb-4">Insights</h1>
          <div className="flex flex-wrap items-end space-x-4 mb-4">
          <div className="flex-1 min-w-[200px] max-w-[250px]">
              <label htmlFor="date-selection" className="mb-1 text-sm font-medium text-gray-700">Date Range</label>
              <DateSelection
                id="date-selection"
                start={startDate}
                end={endDate}
                setDefaultDates={setDefaultDates}
                handleStartDate={handleStartDate}
                handleEndDate={handleEndDate}
                handleDateChange={handleDateChange}
              />
            </div>
          </div>
        </header>

        <div className="flex flex-col md:flex-row gap-6 h-[155px]">
          <div className="w-full md:w-[74%] flex flex-col md:flex-row gap-6">
            <div className="w-full md:w-1/2 bg-white rounded-lg shadow p-6">
              <div className="flex items-center mb-4">
                <img src={SessionIcon} alt="Session Icon" className="w-8 h-8 mr-3" />
                <h2 className="text-xl font-semibold">Session</h2>
              </div>
              <div className="flex justify-between">
                <div className="w-1/3">
                  <p className="text-sm text-gray-500">Amount</p>
                  <p className="text-3xl font-bold text-[#1F2937]">{userData.sessionCount || 0}</p>
                </div>
                <div className="w-1/3">
                  <p className="text-sm text-gray-500">Time (min)</p>
                  <p className="text-3xl font-bold text-[#1F2937]">{((duration / 1000 / 60) || 0).toFixed(0)}</p>
                </div>
                <div className="w-1/3">
                  <p className="text-sm text-gray-500">Modules</p>
                  <p className="text-3xl font-bold text-[#1F2937]">{moduleCount || 0}</p>
                </div>
              </div>
            </div>
            <div className="w-full md:w-1/2 bg-white rounded-lg shadow p-6">
              <div className="flex items-center mb-4">
                <img src={NegotiationIcon} alt="Negotiation Icon" className="w-8 h-8 mr-3" />
                <h2 className="text-xl font-semibold">Negotiation</h2>
              </div>
              <div className="flex justify-between">
                <div className="w-1/3">
                  <p className="text-sm text-gray-500">Amount</p>
                  <p className="text-3xl font-bold text-[#1F2937]">{negotiationCount || 0}</p>
                </div>
                <div className="w-1/3">
                  <p className="text-sm text-gray-500">Time (min)</p>
                  <p className="text-3xl font-bold text-[#1F2937]">{((negotiationTime / 1000 / 60) || 0).toFixed(0)}</p>
                </div>
                <div className="w-1/10"></div>
              </div>
            </div>
          </div>
          {showCertificateCard && (<div className="w-full md:w-[26%]">
            <CertificateCard email={user.email} startDate={startDate} endDate={endDate} />
          </div>)}
        </div>

        <div 
          ref={tabsRef}
          className={`${isTabsSticky ? 'sticky top-0 z-10 bg-gray-100 py-4' : ''}`}
        >
          <nav className="flex space-x-4 mb-4" aria-label="Tabs">
            {['Trainee Analytics', 'Top Negotiations'].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`
                  px-3 py-2 text-sm font-medium rounded-md
                  ${activeTab === tab
                    ? 'bg-[#071146] text-white'
                    : 'text-black-500 hover:bg-indigo-100'}
                  transition-colors duration-150 ease-in-out
                `}
              >
                {tab}
              </button>
            ))}
          </nav>

          <div>
            {activeTab === 'Trainee Analytics' && table2bData && <Table2 data={table2bData} reactVerbosity={reactVerbosity} />}
            {activeTab === 'Top Negotiations' && topNegTableData && <Table2 data={topNegTableData} reactVerbosity={reactVerbosity} />}
          </div>
        </div>
      </div>

      {showFloatingButton && (
        <button
          onClick={handleFloatingButtonClick}
          className="fixed bottom-8 right-8 bg-blue-500 text-white p-2 rounded-full shadow-lg hover:bg-blue-600 transition-colors duration-200"
          aria-label="Scroll to top"
        >
          ↑
        </button>
      )}
    </div>
  );
};

export default TraineeDash;
